<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="username"
          label="Username"
          outlined
        />
      </v-col>
      <v-col cols="12" style="margin-top: -35px;">
        <v-text-field
          v-model="password"
          label="Password"
          outlined
          type="password"
          @keyup.enter="login"
        />
      </v-col>
    </v-row>
    <v-btn
      color="primary"
      @click="login"
    >
      Login
    </v-btn>

    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/travels.jpg')"
          class="my-3"
          contain
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

//vue 3 style
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import store from '../store/index.js'

export default {
  name: 'HomeView',
  setup() {
    const username = ref('')
    const password = ref('')
    const router = useRouter()

    const login = () => {
      //if username and password are not admin admin then show error
      if (username.value !== 'darren' || password.value !== '2025') {
        alert('Invalid username or password', 'Error', 'error')
        return
      }

      //set store auth to true
      store.dispatch('login');

      //if username and password are admin admin then redirect to /2025
      router.push('/')
    }

    return {
      username,
      password,
      login
    }
  }
}
</script>